import React from 'react'
import { Typography, Divider, withStyles } from '@material-ui/core'
import styles from './styles'

const ActivitySelection = props => {
  const { data, selectedIndex, selectedData, onSelect, classes } = props
  return (
    <div className={classes.content}>
      <div>
        <Typography className={classes.header}>
          Choose an Interaction
        </Typography>
        <Typography className={classes.note}>
          Choose an activity that best fits your content to create an engaging
          learning experience. <br></br>Activities use only text from the
          corresponding page.
        </Typography>
      </div>
      {data.suggestions.map((item, index) => (
        <div
          key={index}
          className={classes.selectContainer}
          onClick={() => onSelect(item, index)}
          style={{
            border:
              selectedIndex === index
                ? '1px solid var(--mcg-blue, #015FFB)'
                : '1px solid var(--Gray-Lighter, #E5E7EB)',
            boxShadow:
              selectedIndex === index
                ? '0px 0px 2px 0px rgba(145, 158, 171, 0.12), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)'
                : 'none',
            cursor: 'pointer',
          }}
        >
          <div className={classes.titleContainer}>
            <Typography className={classes.headerSelect}>
              {item.title}
            </Typography>
          </div>
          <div className={classes.badgeContainer}>
            <div className={classes.badgeLeft}>
              <Typography className={classes.badgeTitle}>
                {item.interaction_type}
              </Typography>
            </div>
            <div className={classes.badgeRight}>
              <Typography className={classes.badgeTitle}>
                {item.technical_complexity}
              </Typography>
            </div>
          </div>
          <div className={classes.descriptionContainer}>
            <Typography className={classes.description}>
              {item.description}
            </Typography>
          </div>
          {selectedIndex === index && (
            <>
              <div className={classes.dividerContainer}>
                <Divider className={classes.divider} />
              </div>
              <div>
                <Typography className={classes.description}>
                  <span className={classes.educationalText}>
                    Educational value:{' '}
                  </span>
                  {item.educational_value}
                </Typography>
              </div>
              <div className={classes.descriptionContainer}>
                <Typography className={classes.description}>
                  <span className={classes.educationalText}>Elements: </span>
                  {item.elements}
                </Typography>
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  )
}

export default withStyles(styles)(ActivitySelection)
